import { Values } from "../types";

export function getInitialValues(values: Partial<Values>): Values {
  return {
    attestation: values.attestation,
    date: values.date,
    justification: values.justification,
    draft_key: values.draft_key,
    systems: values.systems || [],
    type: values.type,
    users: values.users || [],
    revoke_type: values.revoke_type,
    target: values.target || "SELF",
  };
}
